import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/global.css';

export default function CategoryCard({ id, name, image }) {
  return (
    <Link to={`/category/${id}`} style={{ textDecoration: 'none' }}>
      <div className="card">
        <img
          src={image || 'https://via.placeholder.com/300x200?text=No+Image'}
          alt={name}
          className="card-image"
          onError={(e) => {
            e.target.src = 'https://via.placeholder.com/300x200?text=No+Image';
          }}
        />
        <div className="card-body">
          <h3 className="card-title">{name}</h3>
          <button className="btn btn-primary" style={{ width: '100%' }}>
            View Items
          </button>
        </div>
      </div>
    </Link>
  );
}
